module.exports = __webpack_public_path__ + "img/step_4.4812fe21.png";